import _ from 'lodash';

export { _ };

export const validateFileName = (file, def_ext = '.png') => {
  let localFile = file;
  let fileName = localFile.name.replace(/ |-/g, '_');
  fileName = /[.]/.exec(fileName) ? fileName : fileName + def_ext;
  localFile = new File([localFile], fileName);
  return localFile;
};

export const analyzeImage = (imgElement) => {
  if (!imgElement) return null;
  if (!imgElement.complete) return null;
  if (!imgElement.width) return null;
  if (!imgElement.height) return null;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = imgElement.width;
  canvas.height = imgElement.height;

  try {
    ctx.drawImage(imgElement, 0, 0, imgElement.width, imgElement.height);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const { data } = imageData;

    let r = 0,
      g = 0,
      b = 0;
    for (let i = 0; i < data.length; i += 4) {
      r += data[i];
      g += data[i + 1];
      b += data[i + 2];
    }

    const pixelCount = data.length / 4;
    r = Math.floor(r / pixelCount);
    g = Math.floor(g / pixelCount);
    b = Math.floor(b / pixelCount);

    return r * 0.299 + g * 0.587 + b * 0.114;
  } catch (error) {
    console.error('Cross-origin issue with image data:', error);
    return null;
  }
};
